module.exports = "https://static.wmbcdn.com/uniweb/images/51ef2eb2bb8891585e0d93f06dcab75d.svg";